<template>
  <div class="dados_casamento">
    <h4 class="headerTitle mt-2">
      Dados do Casamento
    </h4>
    <div class="p-2">
      <div class="row mt-2">
        <div class="col-6">
          <div class="form-group">
            <label for="casamento_tipo"
                   class="label">
              Tipo de casamento <span class="text-danger">*</span>
            </label>
            <select id="casamento_tipo"
                    v-model="habilitacao.tipo_casamento"
                    v-validate="'required'"
                    class="form-control form-control-sm"
                    :class="{'is-invalid':errors.has('tipo_casamento')}"
                    required
                    name="tipo_casamento"
                    @blur="validateInputs('tipo_casamento')"
                    @change="[validateInputs('tipo_casamento'), getAddressCartorio(), verifyDataCasamento(), verifyCasamentoCartorio()]">
              <option :value="null">
                Selecione o tipo
              </option>
              <option v-for="(tipo, index) in selects.tipo"
                      :key="`tipo_casamento_${index}`">
                {{ tipo }}
              </option>
            </select>
            <small v-if="errors.has('tipo_casamento')"
                   class="text-danger">
              Selecione o tipo de casamento.
            </small>
          </div>
        </div>

        <div class="col-3">
          <div class="form-group">
            <label for="dados_casamento_data_entrada"
                   class="label"
                   :class="{'label_error': error_data}">
              Data do casamento
              <span class="text-danger">*</span>
              <IconSvg v-if="error_data"
                       class="icon-error-campo"
                       icon="alert" />
            </label>
            <input id="dados_casamento_data_entrada"
                   ref="data_casamento"
                   v-model="habilitacao.data_casamento"
                   v-validate="`required|date_format:yyyy-MM-dd|date_between:${ '1500-01-01' },${ '2500-01-01' }, (include)`"
                   type="date"
                   class="form-control form-control-sm"
                   :class="{'is-invalid':errors.has('data_casamento') || error_data}"
                   required
                   name="data_casamento"
                   :disabled="errors.has('data_habilitacao') || errors.has('data_entrada') || errors.has('data_expiracao')"
                   @change="validateInputs('data_casamento'), emitChange(null,'data')">
            <small v-if="errors.has('data_casamento')"
                   class="text-danger">
              {{ errors.first('data_casamento') }}
            </small>
          </div>
        </div>

        <div class="col-3">
          <div class="form-group">
            <label for="dados_casamento_data_entrada"
                   class="label">
              Hora do Casamento
              <span v-if="[CASAMENTO_RELIGIOSO, UNIAO_ESTAVEL, CASAMENTO_CIVIL_OUTRO_CARTORIO].indexOf(habilitacao.tipo_casamento) == -1 && habilitacao.tipo_casamento !== UNIAO_ESTAVEL"
                    class="text-danger">*</span>
            </label>
            <input id="dados_casamento_hora_casamento"
                   v-model="habilitacao.hora_casamento"
                   v-validate="{ required: [CASAMENTO_RELIGIOSO, UNIAO_ESTAVEL, CASAMENTO_CIVIL_OUTRO_CARTORIO].indexOf(habilitacao.tipo_casamento) == -1 || propTipo !== 'HABILITACAO' && habilitacao.tipo_casamento !== UNIAO_ESTAVEL}"
                   type="time"
                   class="form-control form-control-sm"
                   :class="{'is-invalid':errors.has('hora_casamento')}"
                   name="hora_casamento"
                   :required="[CASAMENTO_RELIGIOSO, UNIAO_ESTAVEL, CASAMENTO_CIVIL_OUTRO_CARTORIO].indexOf(habilitacao.tipo_casamento) == -1 || propTipo !== 'HABILITACAO' && habilitacao.tipo_casamento !== UNIAO_ESTAVEL"
                   @blur="validateInputs('hora_casamento')"
                   @change="validateInputs('hora_casamento'), emitChange()">
            <small v-if="errors.has('hora_casamento')"
                   class="text-danger">
              Digite a hora do casamento.
            </small>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="casamento_regime"
                   class="label"
                   :class="{'label_error': error_regime}">
              Regime de bens
              <IconSvg v-if="error_regime"
                       class="icon-error-campo"
                       icon="alert" />
            </label>

            <select id="casamento_regime"
                    v-model="habilitacao.regime_bens"
                    v-validate="{'required': propTipo !== 'CASAMENTO'}"
                    class="form-control form-control-sm"
                    :class="{'is-invalid': error_regime || errors.has('regime_bens')}"
                    name="regime_bens"
                    @change="getComplemento(), emitChange(null, 'regime')">
              <option :value="null">
                Selecione o tipo
              </option>
              <option v-for="(regime, index) in regimeDeBens"
                      :key="`regime_casamento_${index}`"
                      :value="regime.value">
                {{ regime.text }}
              </option>
            </select>
            <small class="invalid-feedback">{{ errors.first('regime_bens') }}</small>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="nome_complemento"
                   class="label">
              Nome do complemento
            </label>

            <select id="nome_complemento"
                    v-model="habilitacao.nome_complemento_regime_bens"
                    class="form-control form-control-sm"
                    @change="changeComplemento">
              <option :value="null">
                Selecione o nome
              </option>
              <option v-for="(regimeComplemento, index) in complementos"
                      :key="`complemento_regime_casamento_${index}`"
                      :value="regimeComplemento.complemento">
                {{ regimeComplemento.nome }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-12">
          <div class="form-group">
            <label for="regime_bens_complemento"
                   class="label">
              Complemento do regime de bens
            </label>
            <textarea v-model="habilitacao.regime_bens_complemento"
                      class="form-control form-control-sm w-100"
                      placeholder="Regime de bens complemento"
                      cols="30"
                      rows="4"
                      @change="emitChange()" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* services */
  import RegimeBensService from "@/services/Registros/RegimeBensService"

  /* constants */
  import { tipos, EDITAL_OUTRA_SERVENTIA, A_VISTA_HABILITACAO, UNIAO_ESTAVEL, CASAMENTO_RELIGIOSO_EFEITO_CIVIL, CASAMENTO_RELIGIOSO, CASAMENTO_CIVIL_OUTRO_CARTORIO } from "@/constants/casamento/tipos"

  /* others */
  import moment from "moment"
  import {mapGetters} from "vuex"

  export default {
    name: "DadosCasamento",
    props: {
      propHabilitacao: {type: Object, default: () => ({})},
      propTipo: {type: String, default: () => 'HABILITACAO'},
      propCartorio: {type: Object, default: () => ({})},
      propCorrecoes: {type: Object, default: () => ({})},
      propEdicao: { type: Boolean, default: () => false },
      propTab: {type: Number, default: () => 0}
    },
    inject: ['$validator'],
    data () {
      return {
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD'),
        selects: {
          tipo: [
            ...tipos
          ],
          regime: [
            { text: "Comunhão parcial de bens" },
            { text: "Comunhão universal de bens" },
            { text: "Participação final aquestos" },
            { text: "Separação de Bens" },
            { text: "Separação legal de bens" },
            { text: "Outros" },
            { text: "Ignorado" }
          ]
        },
        hidden: {
          datas: true,
          small_data_habilitacao: false,
          small_data_expiracao: false
        },
        habilitacao: {
          tipo_casamento: null,
          regime_bens: null,
          nome_complemento_regime_bens: null,
          regime_bens_complemento: null,
          publicacao: 'E_PROCLAMAS',
          data_publicacao: null,
          data_casamento: null,
          hora_casamento: null,
          protocolo_numero: null,
          protocolo_ano: null
        },
        publicacao: 'E_PROCLAMAS',
        complementos: [],
        partes: [],
        regimeDeBens: [
          { value: 'COMUNHAO_PARCIAL', text: "Comunhão parcial de bens" },
          { value: 'COMUNHAO_UNIVERSAL', text: "Comunhão universal de bens" },
          { value: 'PARTICIPACAO_FINAL_AQUESTOS', text: "Participação final aquestos" },
          { value: 'SEPARACAO_BENS', text: "Separação de Bens" },
          { value: 'SEPARACAO_LEGAL_BENS', text: "Separação legal de bens" },
          { value: 'OUTROS', text: "Outros" },
          { value: 'IGNORADO', text: "Ignorado" }
        ],
        showAddress: false,
        error_data: false,
        error_regime: false,
        error_observacoes: false,
        A_VISTA_HABILITACAO,
        EDITAL_OUTRA_SERVENTIA,
        UNIAO_ESTAVEL,
        CASAMENTO_RELIGIOSO_EFEITO_CIVIL,
        CASAMENTO_RELIGIOSO,
        CASAMENTO_CIVIL_OUTRO_CARTORIO
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      }),
    },
    watch: {
      propHabilitacao () {
        this.habilitacao = this.propHabilitacao
        this.init()
        this.getComplemento()
        this.getPublicacao()

        this.showAddress = !this.habilitacao.casamento_em_cartorio
      },
      propCorrecoes () {
        this.verifyErrorsCarga()
      },
      propTab () {
        if (this.propTab == 2) {
          this.verifyFocus()
        }
      }
    },

    created () {
      this.habilitacao = this.propHabilitacao

      // Alguns legados não vem com local nem endereço
      if (!this.habilitacao.registro.local) {
        this.habilitacao.registro.local = {
          endereco: {}
        }
      }

      this.showAddress = !this.habilitacao.casamento_em_cartorio
    },

    mounted () {
      this.ativarData()
      this.getComplemento()
      this.init()
      this.verifyErrorsCarga()
      this.getPublicacao()
      this.verifyFocus()
    },
    methods: {
      init () {
        this.partes = this.propHabilitacao.registro.partes

        if (this.habilitacao.hora_casamento) {
          this.habilitacao.hora_casamento = moment(this.habilitacao.hora_casamento, 'HH:mm').format('HH:mm')
        }
      },
      emitChange (deleteds = null, field) {
        if (field) {
          switch (field) {
          case 'data':
            this.deleteError([`DATA DO CASAMENTO`])
          case 'regime':
            this.deleteError([`REGIME DO CASAMENTO`, 'REGIME DE BENS'])
          }
        }

        if (deleteds !== null) {
          this.$emit('onDeleteds', deleteds)
        }

        this.$emit('onChange', this.habilitacao)
      },

      validateInputs (name) {
        this.$validator.validate(name)

        if (name === 'tipo_casamento') this.verifyDataEHora()
      },

      dataAtual () {
        this.habilitacao.data_entrada = moment().format('YYYY-MM-DD')
      },

      ativarData () {
        if (!this.habilitacao.data_entrada) {
          this.dataAtual()
        }
      },
      async getComplemento () {
        if (!this.habilitacao.regime_bens) return

        const { data } = await RegimeBensService.getRegimeBens({
          cartorio_id: this.$store.state.auth.cartorio_id,
          descricao: this.habilitacao.regime_bens,
          ativo: true
        })

        this.complementos = data

        this.emitChange()
      },
      changeComplemento (event) {
        const val = event.target.value

        this.habilitacao.regime_bens_complemento = val

        this.emitChange()
      },
      removeEnderecoParte (endereco) {
        if (endereco.endereco_id) {
          const deleteds = {
            pessoaEnderecos: endereco.endereco_id
          }
          this.emitChange(deleteds)
        }
      },
      getAddressCartorio () {
        if (this.habilitacao.registro.local && this.habilitacao.registro.local.endereco) {
          const endereco = !!Object.values(this.habilitacao.registro.local.endereco).length

          if (endereco) {
            this.emitChange()
            return
          }
        }

        this.habilitacao.registro.local.endereco = {
          uf: this.propCartorio.endereco ? this.propCartorio.endereco.uf : '',
          cidade: this.propCartorio.endereco ? this.propCartorio.endereco.cidade : '',
          ibge: this.propCartorio.endereco ? this.propCartorio.endereco.ibge : null,
        }

        this.emitChange()
      },

      getAddressNotCartorio () {
        setTimeout(() => {
          this.habilitacao.casamento_em_cartorio = !!this.habilitacao.casamento_em_cartorio
          this.emitChange()

          this.showAddress = !this.habilitacao.casamento_em_cartorio
        }, 300)

        if (this.habilitacao.casamento_em_cartorio) {
          this.habilitacao.registro.local.endereco = {
            uf: this.propCartorio.endereco ? this.propCartorio.endereco.uf : '',
            cidade: this.propCartorio.endereco ? this.propCartorio.endereco.cidade : '',
            ibge: this.propCartorio.endereco ? this.propCartorio.endereco.ibge : null,
          }
        } else {
          this.habilitacao.registro.local.endereco = {}
        }

        this.emitChange()
      },
      verifyErrorsCarga () {
        this.error_data = false
        this.error_regime = false

        Object.keys(this.propCorrecoes).forEach(key => {
          if ([`DATA DO CASAMENTO`].indexOf(key) != -1) this.error_data = true
          if ([`REGIME DO CASAMENTO`, 'REGIME DE BENS'].indexOf(key) != -1) this.error_regime = true
        })
      },
      deleteError (errors) {
        this.$emit('deleteError', errors)
      },
      localPublicacao (local) {
        this.habilitacao.publicacao = local

        this.emitChange()
      },
      getPublicacao () {
        const {publicacao} = this.habilitacao
        // deixando no formato de data
        this.habilitacao.data_publicacao = this.habilitacao.data_publicacao ? moment(this.habilitacao.data_publicacao).format('YYYY-MM-DD') : null

        if (publicacao === 'E_PROCLAMAS' || publicacao === 'NAO_PUBLICAR') {
          this.publicacao = publicacao
        } else {
          this.publicacao =  'OUTRO_JORNAL'
        }
      },
      changeJornal () {
        this.habilitacao.publicacao = null
        this.habilitacao.data_publicacao = null
      },
      changeCasamentoCartorio () {
        this.habilitacao.casamento_em_cartorio = !this.habilitacao.casamento_em_cartorio

        this.getAddressNotCartorio()
      },
      verifyDataCasamento () {
        if (!this.habilitacao.data_casamento) {
          this.habilitacao.data_casamento === null
        }

        this.validateInputs('data_casamento')
      },
      verifyDataEHora () {
        if (this.habilitacao.tipo_casamento === this.EDITAL_OUTRA_SERVENTIA) {
          this.habilitacao.data_casamento = null
          this.habilitacao.hora_casamento = null

          this.emitChange(null, 'data')
        }
      },
      validateDataCasamento (input) {
        this.habilitacao.data_casamento = input.target.value

        this.verifyDataCasamento()
      },
      verifyFocus () {
        if (this.propTipo == 'CASAMENTO' && this.propHabilitacao.registro_id) {
          if (this.habilitacao.tipo_casamento == 'Afixação de edital de outra serventia' && this.$refs["nome_juiz"]) {
            this.$refs["nome_juiz"].focus()
          } else if (this.$refs["data_casamento"]) {
            this.$refs["data_casamento"].focus()
          }
        }
        else {
          if (this.propTipo == 'CASAMENTO' && this.$refs["tipo_casamento"]) {
            this.$refs["tipo_casamento"].focus()
          } else if (this.$refs["data_entrada"]) {
            this.$refs["data_entrada"].focus()
          }
        }
      },
      verifyCasamentoCartorio () {
        if (this.habilitacao.tipo_casamento == this.CASAMENTO_RELIGIOSO || this.habilitacao.tipo_casamento == this.CASAMENTO_RELIGIOSO_EFEITO_CIVIL) {
          this.habilitacao.casamento_em_cartorio = false
        } else {
          this.habilitacao.casamento_em_cartorio = true
        }
      },
    }
  }
</script>

<style lang="scss">
@import "../../../../scss/_components/resumos";

.fs-14 {
  font-size: 14px;
}

.headerTitle {
  @extend %titleBox--sm;
  background-color: $color-gray-light;
}

</style>
